import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ViewModeIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M22 20.25H4.2498L6.4166 18.625H20C20.3447 18.625 20.625 18.3447 20.625 18C20.625 17.6553 20.3447 17.375 20 17.375H8.0833L10.4167 15.625H18C18.3447 15.625 18.625 15.3447 18.625 15C18.625 14.6553 18.3447 14.375 18 14.375H12.0836L14.417 12.625H16C16.3447 12.625 16.625 12.3452 16.625 12C16.625 11.6548 16.3447 11.375 16 11.375H14.75V3.99996C14.75 3.60986 14.4512 3.28516 14.0625 3.25236L2.0625 2.25236C1.853 2.23916 1.647 2.30656 1.4922 2.44816C1.3379 2.59026 1.25 2.78996 1.25 2.99996V21C1.25 21.4142 1.5858 21.75 2 21.75H22C22.4141 21.75 22.75 21.4141 22.75 21C22.75 20.5859 22.4141 20.25 22 20.25ZM10.625 4.47116L13.25 4.68996V7.59156L10.625 8.46646V4.47116ZM10.625 9.78356L13.25 8.90856V11.625L10.625 13.5938V9.78356ZM6.625 4.13786L9.375 4.36696V8.88306L6.625 9.79966V4.13786ZM6.625 11.1169L9.375 10.2002V14.5312L6.625 16.5937V11.1169ZM2.75 3.81486L5.375 4.03366V10.2164L2.75 11.0913V3.81486ZM2.75 12.4087L5.375 11.5336V17.5312L2.75 19.5V12.4087Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ViewModeIcon.displayName = 'ViewModeIcon';
